import {
  PROMOTIONAL_OFFER_ADD,
  PROMOTIONAL_OFFER_UPDATE,
  PROMOTIONAL_OFFER_DELETE,
  PROMOTIONAL_OFFER_LIST,
  PROMOTIONAL_OFFER_VIEW,
  PROMOTIONAL_OFFER_ACTIVE,
} from "../types";

export const promotionalOfferAddAction = (data, onSuccess, onError) => {
  return { type: PROMOTIONAL_OFFER_ADD, data, onSuccess, onError };
};

export const promotionalOfferUpdateAction = (data, onSuccess, onError) => {
  return { type: PROMOTIONAL_OFFER_UPDATE, data, onSuccess, onError };
};

export const promotionalOfferDeleteAction = (data, onSuccess, onError) => {
  return { type: PROMOTIONAL_OFFER_DELETE, data, onSuccess, onError };
};

export const promotionalOfferListAction = (data, onSuccess, onError) => {
  return { type: PROMOTIONAL_OFFER_LIST, data, onSuccess, onError };
};

export const promotionalOfferViewAction = (data, onSuccess, onError) => {
  return { type: PROMOTIONAL_OFFER_VIEW, data, onSuccess, onError };
};

export const promotionalOfferActiveAction = (data, onSuccess, onError) => {
  return { type: PROMOTIONAL_OFFER_ACTIVE, data, onSuccess, onError };
};
